export default "__VITE_ASSET__amdVAdQv__"